module.exports = __webpack_public_path__ + "static/media/E4.b56fa050.mp3";